import React from 'react';
import { Typography } from '@mui/material';
import { IBooking } from '../../../utils/entities/interface';
import { CurrencyRupee, RemoveRedEyeOutlined } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { ListTable } from '../../molecules/ListTable';
import { capitalizeWords, formatPhoneNumber } from '../../../utils/helper';
import { buildBookingDetailState } from '../../../utils/bookingNavigation';

export const PaymentsList = ({
  Bookings,
  isLoading,
  headerCells,
}: {
  Bookings: IBooking[];
  isLoading: boolean;
  headerCells: [string, number][];
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const actions = [
    {
      icon: <RemoveRedEyeOutlined />,
      onClick: (booking: IBooking) =>
        navigate(`/bookings/assign/${booking._id}`, {
          state: buildBookingDetailState('payments', {
            returnSearch: location.search,
          }),
        }),
    },
  ];

  return (
    <ListTable
      headerCells={headerCells}
      rows={Bookings}
      isLoading={isLoading}
      noDataText="No payments found"
      actions={actions}
      renderCell={(booking: IBooking, colIndex: number) => {
        switch (colIndex) {
          case 0:
            return booking.bookingId || 'N/A';
          case 1:
            return capitalizeWords(booking.user?.name) || 'N/A';
          case 2:
            return booking?.user?.phoneNumber
              ? formatPhoneNumber(booking.user.phoneNumber)
              : 'N/A';
          case 3:
            return capitalizeWords(booking?.technicianName?.name) || 'N/A';
          case 4:
            return (
              booking?.technician?.phoneNumber ||
              booking?.technicianName?.phoneNumber
                ? formatPhoneNumber(
                    booking?.technician?.phoneNumber ||
                      booking?.technicianName?.phoneNumber,
                  )
                : 'N/A'
            );
          case 5:
            return (
              <Typography
                component="span"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CurrencyRupee sx={{ fontSize: 13, mr: 0.25 }} />
                {Number(booking?.grandTotal || 0).toLocaleString('en-IN', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            );
          default:
            return null;
        }
      }}
    />
  );
};
